<div class="usan-form-item nucleic-acid-salts-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasNucleicAcidSaltsFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column">
      <span class="usan-form-item nucleic-acid-salts-item nucleic-acid-salts-text">
        Nucleic acids salts
        <ul>
          <li>Sequence as an MS-Word Document</li>
          <li>ChemDraw files showing the structures of the oligonucleotide and its salt</li>
          <li>&lt;30 base pairs, for other oligonucleotides, gene therapies and cell therapies please use form F or contact USAN staff for advice</li>
        </ul>
      </span>
    </div>
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-nucleic-acid-salts form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload nucleic acid salts
    </button>
  </div>
  <ng-container *ngIf="hasNucleicAcidSaltsFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>